/* Daily Smile premium (ronde 11, snel). Bron, niet geminificeerd.
   Draait 1 keer bij laden en daarna niets meer tijdens scrollen: alle scrollbeweging zit in CSS (scroll timelines).
   Splitst koppen in letters, zet de woorden van de zin klaar, start de sfeervideo pas na het laden en alleen in beeld,
   en toont een cursorlabel boven productbeelden. Niets bij prefers-reduced-motion. */
(function () {
  var html = document.documentElement;
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var timelines = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
  if (!still && timelines) html.classList.add('ds-pv');

  /* Letters splitsen, schermlezers lezen de originele zin */
  $$('[data-split]').forEach(function (el) {
    var text = el.textContent.trim(); var i = 0;
    el.setAttribute('aria-label', text);
    el.textContent = '';
    text.split(' ').forEach(function (word, wi, arr) {
      var w = document.createElement('span'); w.className = 'w'; w.setAttribute('aria-hidden', 'true');
      var clip = document.createElement('span'); clip.className = 'clip';
      word.split('').forEach(function (ch) { var c = document.createElement('span'); c.className = 'c'; c.textContent = ch; c.style.setProperty('--i', i++); clip.appendChild(c); });
      w.appendChild(clip); el.appendChild(w);
      if (wi < arr.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.classList.add('ds-split');
  });
  requestAnimationFrame(function () { requestAnimationFrame(function () { $$('[data-split]').forEach(function (el) { el.classList.add('is-in'); }); }); });

  /* Zin: woorden apart, elk woord krijgt zijn plek (--k) in de scrollbeweging */
  $$('[data-zin]').forEach(function (el) {
    var acc = (el.getAttribute('data-acc') || '').toLowerCase().split('|').filter(Boolean);
    var words = el.textContent.trim().split(/\s+/); el.textContent = '';
    var frag = document.createDocumentFragment();
    words.forEach(function (w, i) {
      var s = document.createElement('span'); s.className = 'zw'; s.textContent = w;
      s.style.setProperty('--k', (i / Math.max(words.length - 1, 1)).toFixed(3));
      if (acc.indexOf(w.toLowerCase().replace(/[.,!?]/g, '')) > -1) s.classList.add('is-acc');
      frag.appendChild(s); if (i < words.length - 1) frag.appendChild(document.createTextNode(' '));
    });
    el.appendChild(frag);
  });

  /* Sfeervideo: pas na het laden van de pagina, alleen in beeld, niet bij databesparing */
  var vid = document.querySelector('.ds-cine__video');
  if (vid) {
    vid.muted = true;
    var save = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    if (still || save) { vid.removeAttribute('autoplay'); vid.pause(); }
    else {
      var inView = true;
      var vplay = function () { if (!document.hidden && inView) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); } else { vid.pause(); } };
      var start = function () {
        vid.preload = 'auto';
        if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; vplay(); }).observe(vid);
        document.addEventListener('visibilitychange', vplay);
        vplay();
      };
      var later = function () { setTimeout(start, 600); };
      if (document.readyState === 'complete') later(); else addEventListener('load', later, { once: true });
    }
  }

  /* Knop in het productpodium scrolt naar de koopsectie */
  var buy = document.querySelector('[data-ps-buy]'), box = document.querySelector('[data-ds-pdp]');
  if (buy && box) buy.addEventListener('click', function (e) { e.preventDefault(); box.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' }); });

  /* Cursorlabel boven productbeelden: alleen muis, alleen een lus zolang het label beweegt */
  if (fine && !still) {
    var cur = document.createElement('div'); cur.className = 'ds-cursor'; cur.setAttribute('aria-hidden', 'true');
    var lab = document.createElement('span'); cur.appendChild(lab); document.body.appendChild(cur);
    var tx = -200, ty = -200, cx = -200, cy = -200, on = false, loop = 0;
    var step = function () {
      cx += (tx - cx) * .22; cy += (ty - cy) * .22;
      cur.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      loop = (Math.abs(tx - cx) > .4 || Math.abs(ty - cy) > .4) ? requestAnimationFrame(step) : 0;
    };
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('[data-cursor]');
      if (t) { lab.textContent = t.getAttribute('data-cursor'); if (!on) { cx = tx = e.clientX; cy = ty = e.clientY; step(); } on = true; cur.classList.add('is-on'); }
      else if (on) { on = false; cur.classList.remove('is-on'); }
    }, { passive: true });
    document.addEventListener('pointermove', function (e) { if (!on) return; tx = e.clientX; ty = e.clientY; if (!loop) loop = requestAnimationFrame(step); }, { passive: true });
  }
})();
